import { takeEvery, select } from 'redux-saga/effects';
import { CART_ACTION_TYPES } from '../../actions';
import { lineItemsObjectsSelector } from '../../../checkout/selectors/line_items';
import { orderTotalSelector } from '../../../checkout/selectors/order';
import ga4DataLayer from '../../../services/ga4_datalayer';

const mobileScreenWidth = 540;

// Delay gives the GTM GA4 Event tag a window to fire before navigation.
const REDIRECT_DELAY_MS = 300;

// CurrentOrderSerializer reports `price` as the variant's full_price and
// `discount` as the per-line total markdown ((full - line_item.price) * qty).
// GA4 wants the unit price the user actually pays, so collapse to a
// post-discount per-unit number before pushing.
function netUnitPrice(lineItem) {
  const price = Number(lineItem.price) || 0;
  const discount = Number(lineItem.discount) || 0;
  const quantity = Math.max(Number(lineItem.quantity) || 1, 1);
  return price - discount / quantity;
}

export function* openCartRequest() {
  if (window.innerWidth < mobileScreenWidth) {
    window.scrollService.disableScroll();
    const cartWrapper = document.querySelector('.cart-wrapper');
    if (cartWrapper) { // CartWrapper may be not loaded
      cartWrapper.style.height = `${window.innerHeight}px`;
    }
  }

  const lineItems = yield select(lineItemsObjectsSelector);
  const orderTotal = yield select(orderTotalSelector);
  const itemsForGa4 = lineItems.map((li) => ({ ...li, price: netUnitPrice(li) }));
  ga4DataLayer.trackViewCart(itemsForGa4, orderTotal);
}

export function closeCartRequest() {
  window.scrollService.enableScroll();
}

function redirectToShop() {
  window.location.href = '/shop/checkout_now/';
}

export function* goToCheckout() {
  const lineItems = yield select(lineItemsObjectsSelector);
  const orderTotal = yield select(orderTotalSelector);
  const itemsForGa4 = lineItems.map((li) => ({ ...li, price: netUnitPrice(li) }));
  ga4DataLayer.trackBeginCheckout(itemsForGa4, orderTotal);
  setTimeout(redirectToShop, REDIRECT_DELAY_MS);
}

export default function* cartSaga() {
  yield takeEvery(CART_ACTION_TYPES.OPEN_CART, openCartRequest);
  yield takeEvery(CART_ACTION_TYPES.CLOSE_CART, closeCartRequest);
  yield takeEvery(CART_ACTION_TYPES.CHECKOUT_REQUEST, goToCheckout);
}
